<!-- 变配电弹框图表 -->
<template>
  <div class="powerData">
    <div class="power_header">
      <div>当前总功率 (kWh)</div>
      <time-type-select
        v-model="timeValue"
        @change="timeChangeEvent"
      ></time-type-select>
    </div>
    <div class="power_body">
      <div class="power_left">
        <custom-progress-circle
          showType="1"
          :text="setText(powerDataTotal)"
          :value="100"
          color="#2D82FF"
        >
        </custom-progress-circle>
      </div>
      <div class="power_right">
        <custom-charts :timer="timeValue" :dataList="dataList"></custom-charts>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      timeValue: "day",
      dataList: {
        x: [],
        y: [],
      },
      numVal: null,
    };
  },
  props: {
    powerData: Object,
    pdjName: String,
  },
  watch: {
    powerData() {
      this.loadData(10, 13);
    },
    pdjName() {
      this.loadData();
    },
  },
  created() {
      this.loadData(10, 13);
  },
  computed: {
    powerDataTotal() {
      return this.powerData?.totalPower;
    },
  },
  methods: {
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      if (this.powerData?.historical[this.timeValue]["用电量"])
        this.powerData?.historical[this.timeValue]["用电量"].map((item) => {
          let [res] = Object.entries(item);
          this.dataList.x.push(res[0].slice(first, end));
          this.dataList.y.push(res[1]);
        });
    },
    setText(val) {
      if (this.pdjName == "PDJ_A") {
        this.numVal = "05";
      } else {
        this.numVal = "06";
      }
      if (!val) {
        return "-";
      } else {
        return val[this.numVal];
      }
    },
    timeChangeEvent(data) {
      this.timeValue = data;
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.powerData {
  width: 100%;
  height: 181px;

  .power_header {
    font-size: 14px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .power_body {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    // overflow: hidden;
    .power_left {
      width: 110px;
      height: 110px;
    }

    .power_right {
      width: 203px;
      height: 110px;
      margin-left: 10px;
    }
  }
}
</style>
